'use strict';

import { EditInlineNodeCommand } from 'substance'

class EditXRefCommand extends EditInlineNodeCommand {}

export default EditXRefCommand